export interface ReassignmentKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the Reassignment popup reads. The saved
 * record and AutoPay prefill are per deal; the reasons list is global.
 */
export const reassignmentKeys = {
  all: ["reassignment"] as const,
  details: () => [...reassignmentKeys.all, "detail"] as const,
  detail: (arguments_: ReassignmentKeyArguments) => [...reassignmentKeys.details(), arguments_] as const,
  prefill: (arguments_: ReassignmentKeyArguments) => [...reassignmentKeys.all, "prefill", arguments_] as const,
  reasons: () => [...reassignmentKeys.all, "reasons"] as const,
};
